import { trpc } from '@tg/app-core';
import { useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { BackIcon, I } from './icons';

/** Таб-бар: Главная, Лента (счётчик непрочитанного), Профиль */
export function Tabs({ on }: { on: 'home' | 'feed' | 'profile' }) {
  const nav = useNavigate();
  const feed = trpc.clientApp.feed.useQuery(undefined, { staleTime: 60_000, refetchInterval: 120_000 });
  const n = on === 'feed' ? 0 : feed.data?.unread || 0;
  return (
    <nav className="tabs">
      <button className={on === 'home' ? 'on' : ''} onClick={() => nav('/')}>
        <I n="home" />
        <span>Главная</span>
      </button>
      <button className={on === 'feed' ? 'on' : ''} onClick={() => nav('/feed')}>
        <i className="tbi">
          <I n="bell" />
          {n ? <b className="badge">{n}</b> : null}
        </i>
        <span>Лента</span>
      </button>
      <button className={on === 'profile' ? 'on' : ''} onClick={() => nav('/profile')}>
        <I n="user" />
        <span>Профиль</span>
      </button>
    </nav>
  );
}

/** Заголовок экрана: капсом, оранжевая черта, подзаголовок */
export function Head({ title, sub }: { title: string; sub?: string }) {
  return (
    <>
      <h1 className="h1">{title}</h1>
      <i className="tbar" />
      {sub ? <p className="hsub">{sub}</p> : null}
    </>
  );
}

export const Dots = ({ n, at }: { n: number; at: number }) => (
  <div className="dots">
    {Array.from({ length: n }, (_, i) => (
      <i key={i} className={i === at ? 'on' : ''} />
    ))}
  </div>
);

/** «Назад»: по истории, а если пришли извне (ссылка, возврат в приложение) — на главную */
export function useBack(fallback = '/') {
  const nav = useNavigate();
  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) nav(-1);
    else nav(fallback, { replace: true });
  };
}

export function Top({ title, caps, back = true, right }: { title?: ReactNode; caps?: boolean; back?: boolean; right?: ReactNode }) {
  const goBack = useBack();
  return (
    <header className="top">
      {back ? (
        <button className="ib" onClick={goBack} aria-label="Назад">
          <BackIcon />
        </button>
      ) : (
        <span className="ib ghost" />
      )}
      <div className={'t' + (caps ? ' caps' : '')}>{title}</div>
      {right ?? <span className="ib ghost" />}
    </header>
  );
}

/** Знак отдыха — та же иконка, что в календаре кабинета тренера */
export const RestIcon = () => <img className="resti" src={import.meta.env.BASE_URL + "icons/rest.png"} alt="" />;
